// srs.js
export const MIN_MS = 5 * 60 * 1000;                // 5 min
export const MAX_MS = 60 * 24 * 60 * 60 * 1000;     // 60 days

// base intervals
const BASE = {
  hard:   10 * 60 * 1000,            // 10min
  medium: 24 * 60 * 60 * 1000,       // 1 day
  easy:   3 * 24 * 60 * 60 * 1000,   // 3 days
};

// multipliers
const MULT = {
  hard:   0.5,
  medium: 1.0,
  easy:   2.0,
};

// per-difficulty min/max
const MIN = {
  hard:   1 * 60 * 1000,             // 1 min
  medium: 10 * 60 * 1000,            // 10 min
  easy:   3 * 24 * 60 * 60 * 1000,   // 3 days
};

const MAX = {
  hard:   1 * 24 * 60 * 60 * 1000,   // 1 day
  medium: 3 * 24 * 60 * 60 * 1000,   // 3 days
  easy:   20 * 24 * 60 * 60 * 1000,  // 20 days
};

function normalizeDate(dateLike) {
  if (!dateLike) return null;
  // Firestore Timestamp has a .toDate() method
  if (dateLike.toDate) {
    return dateLike.toDate();
  }
  return new Date(dateLike);
}

export function previousIntervalMs(card) {
  const lastDate = normalizeDate(card?.lastReviewed);
  const nextDate = normalizeDate(card?.nextReview);

  if (!lastDate || !nextDate) return null;

  const last = lastDate.getTime();
  const next = nextDate.getTime();

  if (!Number.isNaN(last) && !Number.isNaN(next) && next > last) {
    return next - last;
  }
  return null;
}

export function msUntil(dateLike) {
  const now = Date.now();
  const t = dateLike ? new Date(dateLike).getTime() : null;
  return t ? Math.max(t - now, 0) : null;
}

export function scheduleNext(card, difficulty) {
  const prev = previousIntervalMs(card);   // from lastReviewed → nextReview
  const base = prev ?? BASE[difficulty];

  let raw = base * MULT[difficulty];

  // First time ever: use base
  if (!prev) raw = BASE[difficulty];

  // Clamp per difficulty
  const min = MIN[difficulty];
  const max = MAX[difficulty];
  let nextInterval = Math.max(min, Math.min(raw, max));

  const nextReview = new Date(Date.now() + nextInterval);
  return { nextReview, nextIntervalMs: nextInterval };
}


// Pretty labels for the buttons
export function prettyInterval(ms) {
  const m = Math.round(ms / 60000);
  if (m < 60) return `${m} min`;
  const h = Math.round(ms / 3600000);
  if (h < 48) return `${h} h`;
  const d = Math.round(ms / 86400000);
  return d === 1 ? "1 dia" : `${d} dias`;
}

export function previewNextLabel(card, difficulty) {
  const prev = previousIntervalMs(card);
  const base = prev ?? BASE[difficulty];
  let raw = base * MULT[difficulty];

  if (!prev) raw = BASE[difficulty];

  const min = MIN[difficulty];
  const max = MAX[difficulty];
  let nextInterval = Math.max(min, Math.min(raw, max));

  return prettyInterval(nextInterval);
}

